/** @format */

import React, { PureComponent } from 'react';
import compose from 'recompose/compose';
import withStyles from '@material-ui/core/styles/withStyles';
import adescomStyle from '../../../../assets/jss/adescom/adescomStyle';
import HeaderCheckBoxSelectList, { HeaderCheckBoxSelectListElement, HeaderListProps } from './HeaderCheckBoxSelectList';

const _ = require('underscore');

const okError = {
    OK: 1,
    ERROR: 2,
};

class HeaderPlkStatus extends PureComponent<HeaderListProps> {
    handleChange = (numbers: Array<number>): void => {
        const { handleChange, fieldName } = this.props;
        const indexArray = [];
        if (_.indexOf(numbers, okError.OK) !== -1) {
            indexArray.push(false);
        }
        if (_.indexOf(numbers, okError.ERROR) !== -1) {
            indexArray.push(true);
        }
        handleChange(fieldName, indexArray, [
            { name: 'prov:state.ok', value: false },
            { name: 'prov:state.error', value: true },
        ]);
    };

    render(): React.ReactNode {
        const { fieldName } = this.props;

        const ok = {} as HeaderCheckBoxSelectListElement;
        const error = {} as HeaderCheckBoxSelectListElement;

        ok.value = okError.OK;
        ok.name = 'prov:state.ok';
        error.value = okError.ERROR;
        error.name = 'prov:state.error';

        return <HeaderCheckBoxSelectList handleChange={this.handleChange} elements={[ok, error]} fieldName={fieldName} />;
    }
}

export default compose<any, any>(withStyles(adescomStyle))(HeaderPlkStatus);
